








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DfiFieldWrapper extends Vue {
  @Prop({ default: "" }) label!: string;
}
